import { Editor as TinyEditor } from '@tinymce/tinymce-react';
import { getBaseName } from 'config/Env';
import { defaultTo } from 'lodash';

export function Editor(props) {
    const baseDir = defaultTo(getBaseName(), '/');

    return (
        <TinyEditor
            tinymceScriptSrc={`${baseDir}tinymce/tinymce.min.js`}
            cloudChannel="7"
            licenseKey="gpl"
            {...props}
        />
    );
}
